import { useState } from "react";

const deelnemers = [
  {
    key: "sarah",
    naam: "Sarah, 47",
    beschrijving:
      "4 jaar uit het arbeidsproces · arbeidsvermogen aanwezig · schulden, weinig dagstructuur en laag zelfvertrouwen.",
    punten: [
      { key: "w0", label: "Week 0", narrative: "Sarah komt binnen. Ze wil wel maar weet niet meer waar te beginnen.", scores: { zelfregie: 15, structuur: 20, participatie: 5, belastbaarheid: 25, perspectief: 10 } },
      { key: "m2", label: "Week 6", narrative: "Slaap is stabieler, ze eet vaker warm. Vertelt in de groep voor het eerst zonder schaamte.", scores: { zelfregie: 30, structuur: 45, participatie: 15, belastbaarheid: 35, perspectief: 25 } },
      { key: "m4", label: "Week 12", narrative: "Na het eerste 3-daagse blok voelt Sarah dat 'het' beweegt. Ze pakt de administratie op met haar buddy.", scores: { zelfregie: 45, structuur: 60, participatie: 35, belastbaarheid: 50, perspectief: 45 } },
      { key: "m8", label: "Maand 8", narrative: "Sarah loopt 2 dagen per week vrijwilligerswerk bij een buurthuis. Haar schulden zijn gesaneerd.", scores: { zelfregie: 70, structuur: 75, participatie: 65, belastbaarheid: 70, perspectief: 70 } },
      { key: "m12", label: "Maand 12", narrative: "Sarah stroomt uit naar een opleiding zorg-assistent, betaald leren-werken bij een lokale zorgorganisatie.", scores: { zelfregie: 85, structuur: 85, participatie: 90, belastbaarheid: 85, perspectief: 90 } },
    ],
  },
  {
    key: "youssef",
    naam: "Youssef, 34",
    beschrijving:
      "Na burn-out anderhalf jaar thuis · hoog opgeleid · vermijdt sociaal contact · onzeker over waarde op arbeidsmarkt.",
    punten: [
      { key: "w0", label: "Week 0", narrative: "Youssef durft nauwelijks buiten te komen. Hij twijfelt over deelname aan de groep.", scores: { zelfregie: 20, structuur: 30, participatie: 5, belastbaarheid: 15, perspectief: 15 } },
      { key: "m2", label: "Week 6", narrative: "Vaste bijeenkomsten geven ritme. Hij ontdekt patronen in overtuigingen, 'ik ben niets waard'.", scores: { zelfregie: 35, structuur: 45, participatie: 20, belastbaarheid: 30, perspectief: 30 } },
      { key: "m4", label: "Week 12", narrative: "Systemisch werk laat zien welke lasten hij droeg voor zijn familie. Hij zet er iets bewust neer.", scores: { zelfregie: 55, structuur: 60, participatie: 40, belastbaarheid: 50, perspectief: 55 } },
      { key: "m8", label: "Maand 8", narrative: "Youssef geeft workshops aan medebewoners. Ontdekt dat hij dat sterker is dan hij dacht.", scores: { zelfregie: 75, structuur: 75, participatie: 70, belastbaarheid: 70, perspectief: 80 } },
      { key: "m12", label: "Maand 12", narrative: "Youssef start als docent bij een taalschool voor nieuwkomers. Werkgevers-training bereidde het team voor.", scores: { zelfregie: 90, structuur: 85, participatie: 85, belastbaarheid: 80, perspectief: 95 } },
    ],
  },
  {
    key: "linda",
    naam: "Linda, 56",
    beschrijving:
      "6 jaar bijstand · alleenstaand · verzorgde jarenlang haar ouders · fysieke klachten · gelooft niet meer in werk.",
    punten: [
      { key: "w0", label: "Week 0", narrative: "Linda is moe en cynisch over 'weer een traject'. Ze komt op verzoek van haar casemanager.", scores: { zelfregie: 25, structuur: 25, participatie: 10, belastbaarheid: 20, perspectief: 5 } },
      { key: "m2", label: "Week 6", narrative: "Warme lunch en vaste groep verrassen haar. Ze begint gesprekken te voeren die ze jaren miste.", scores: { zelfregie: 40, structuur: 45, participatie: 25, belastbaarheid: 30, perspectief: 20 } },
      { key: "m4", label: "Week 12", narrative: "Ze leert grenzen aangeven, na jaren mantelzorg. Fysieke coach helpt bij chronische klachten.", scores: { zelfregie: 55, structuur: 60, participatie: 45, belastbaarheid: 50, perspectief: 40 } },
      { key: "m8", label: "Maand 8", narrative: "Linda doet vrijwilligerswerk in een dagopvang voor ouderen. Ze wordt gewaardeerd voor haar ervaring.", scores: { zelfregie: 70, structuur: 75, participatie: 80, belastbaarheid: 65, perspectief: 70 } },
      { key: "m12", label: "Maand 12", narrative: "Linda werkt 20 uur betaald bij dezelfde dagopvang, met aangepast rooster afgestemd op belastbaarheid.", scores: { zelfregie: 80, structuur: 80, participatie: 90, belastbaarheid: 70, perspectief: 85 } },
    ],
  },
];

const meters = [
  { key: "zelfregie", label: "Zelfregie" },
  { key: "structuur", label: "Structuur" },
  { key: "participatie", label: "Participatie" },
  { key: "belastbaarheid", label: "Belastbaarheid" },
  { key: "perspectief", label: "Toekomstperspectief" },
];

export default function DeelnemerJourney() {
  const [personIdx, setPersonIdx] = useState(0);
  const [active, setActive] = useState(0);
  const person = deelnemers[personIdx];
  const cur = person.punten[active];

  return (
    <div className="bg-[#EFECE5] rounded-3xl border border-[#E5E1D8] p-6 sm:p-10">
      {/* Persoons-switch */}
      <div className="flex flex-wrap gap-2 mb-8">
        {deelnemers.map((d, i) => (
          <button
            key={d.key}
            type="button"
            data-testid={`deelnemer-${d.key}`}
            onClick={() => { setPersonIdx(i); setActive(0); }}
            className={`rounded-full px-4 py-2 text-sm transition-colors border ${
              personIdx === i
                ? "bg-[#1D2A22] text-[#FAF7F1] border-[#1D2A22]"
                : "bg-[#FAF7F1] border-[#E5E1D8] text-[#1D2A22] hover:border-[#1D2A22]"
            }`}
          >
            {d.naam}
          </button>
        ))}
      </div>

      {/* Persoons-info */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 mb-10">
        <div className="lg:col-span-5">
          <p className="text-xs uppercase tracking-[0.25em] text-[#E06B3F] mb-2">
            Voorbeeld-deelnemer · fictief
          </p>
          <p className="font-heading text-4xl text-[#1D2A22] leading-tight">
            {person.naam}
          </p>
          <p className="mt-2 text-[#4A5D4E] text-sm leading-relaxed">
            {person.beschrijving}
          </p>
        </div>
        <div className="lg:col-span-7">
          <p
            data-testid="journey-narrative"
            className="font-heading italic text-xl sm:text-2xl text-[#1D2A22] leading-snug font-light"
          >
            "{cur.narrative}"
          </p>
        </div>
      </div>

      {/* Timeline */}
      <div className="relative mb-8">
        <div className="absolute top-3 left-0 right-0 h-px bg-[#E5E1D8]" />
        <div
          className="absolute top-3 left-0 h-px bg-[#E06B3F] transition-all duration-500"
          style={{ width: `${((active + 1) / person.punten.length) * 100}%` }}
        />
        <div className="grid grid-cols-5 gap-2 relative">
          {person.punten.map((p, i) => (
            <button
              key={p.key}
              data-testid={`journey-step-${p.key}`}
              type="button"
              onClick={() => setActive(i)}
              className="flex flex-col items-center focus:outline-none"
            >
              <span
                className={`w-2.5 h-2.5 rounded-full border-2 transition-all ${
                  active >= i
                    ? "bg-[#E06B3F] border-[#E06B3F]"
                    : "bg-[#FAF7F1] border-[#E5E1D8]"
                } ${active === i ? "scale-150" : ""}`}
              />
              <span
                className={`mt-3 text-[10px] sm:text-xs uppercase tracking-widest ${
                  active === i ? "text-[#E06B3F]" : "text-[#7A8276]"
                }`}
              >
                {p.label}
              </span>
            </button>
          ))}
        </div>
      </div>

      {/* Meters */}
      <div className="space-y-3">
        {meters.map((m) => {
          const v = cur.scores[m.key];
          return (
            <div key={m.key} data-testid={`meter-${m.key}`}>
              <div className="flex items-baseline justify-between mb-1.5">
                <span className="text-xs uppercase tracking-[0.2em] text-[#7A8276]">
                  {m.label}
                </span>
                <span className="font-heading text-lg text-[#1D2A22]">
                  {v}
                  <span className="text-xs text-[#7A8276]">/100</span>
                </span>
              </div>
              <div className="h-2 bg-[#FAF7F1] rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-[#E06B3F] to-[#D19B72] rounded-full transition-[width] duration-700 ease-out"
                  style={{ width: `${v}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
